import { createReducer, on } from '@ngrx/store';
import { PageSearchResult } from '../../models';
import { SubmitSearchSuccess } from '../actions';
import { INIT_SEARCH_STATE } from '../init-data';

export interface SearchState {
  searchString: string;
  results?: PageSearchResult[];
  message?: string;
}

export const initialState = INIT_SEARCH_STATE;

export const reducer = createReducer(
  initialState,
  on(SubmitSearchSuccess, (_, { query: searchString, results, message }) => ({ ..._, searchString, results: results?.map(e => e.content), message }))
);
